module.exports = __webpack_public_path__ + "img/45.31734adc.png";